//GZ-952
if ( document.querySelectorAll('.mmCarousel').length && document.documentElement.clientWidth >= 1000 ) {
    document.querySelectorAll('.mmCarouselControl').forEach(item => {
        item.addEventListener('click', event => {
            let action = item.classList.contains('mmCarouselPrev') ? 'RightToLeft' : 'LeftToRight';
            let titleCarousel;

            if(item.dataset.target && item.dataset.target.indexOf('gz-benessere-swiper') != -1) {
                titleCarousel = 'Benessere';
            }else if(item.dataset.target && item.dataset.target.indexOf('gz-ristoranti-swiper') != -1) {
                titleCarousel = 'Ristoranti GialloZafferano';
            }else if(item.dataset.target && item.dataset.target.indexOf('gz-vodcast-swiper') != -1) {
                titleCarousel = 'Vodcast';
            }else{
                titleCarousel = item.closest('.gz-swiper-button-wrap').parentNode.querySelector('h3').textContent.toUpperCase();
            }

            if(!item.classList.contains('mmCarouselDisabled')){
                eventAnalytics(action, 'CarouselSwipeHP2Desktop', titleCarousel);
            }
        });
    });
}

let dropdowns = document.querySelectorAll('.gz-btn-link-menu');
if(dropdowns.length > 0) {
    let agent = getDeviceType();

    if(agent == 'Mobile' || agent == 'Tablet') {
        dropdowns.forEach(item => {
            item.addEventListener('click', () => {
                item.parentElement.classList.toggle('dropdown-active');
                item.classList.toggle('gz-btn-link-menu-active');
            });
        });
    }
}

/*
if (document.querySelectorAll('.gz-index-nav').length) {
    document.querySelectorAll('.gz-index-nav .gz-btn-link.gz-btn-link-club a').forEach(link => {
        link.addEventListener('click', event => {
            if(link.textContent.toLowerCase() == "scopri gz club") {
                eventAnalytics('Click su Scopri GZ Club', 'GZ Club', window.location.href);
            }
        });
    });
}
*/

//evento analytics
const carousels = document.querySelectorAll('.gz-page .mmCarousel');
const arrayCarousels = Array.from(carousels);

let observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if ( entry.intersectionRatio == 1 ) {

            console.log(entry);

            let titleCarousel;

            if(entry.target.dataset.swipername && entry.target.dataset.swipername.indexOf('gz-benessere-swiper') != -1) {
                titleCarousel = 'Benessere';
            } else if(entry.target.dataset.swipername && entry.target.dataset.swipername.indexOf('gz-ristoranti-swiper') != -1) {
                titleCarousel = 'Ristoranti GialloZafferano';
            }else if(entry.target.dataset.swipername && entry.target.dataset.swipername.indexOf('gz-vodcast-swiper') != -1) {
                titleCarousel = 'Vodcast';
            }else {
                titleCarousel = entry.target.previousElementSibling.querySelector('h3').textContent.toUpperCase();
            }
            var indexCarousel = arrayCarousels.indexOf(entry.target) + 1;

            /*
            eventAnalytics('view', 'CarouselHP', titleCarousel+'_'+indexCarousel, true);
            */

            console.log('CarouselHP',titleCarousel);

            observer.unobserve(entry.target);

        }
    });
}, {threshold: 1, rootMargin: "0px 50px"});

for (const carousel of carousels) {
    observer.observe(carousel);
}

(addRaccomandatoreGetter = () => {
    if(document.location.pathname != "/") return false; //se non siamo in home, stop.

    postTcfReady(startGetter);

    async function startGetter() {
        let items = getCookieCommon("raccomandatore") || null;
        if(items) {
            localStorage.setItem('raccomandatore',encodeURIComponent(items));
        } else {
            if(localStorage.getItem('raccomandatore')) items = localStorage.getItem('raccomandatore');
        }

        if(items) {
            items = JSON.parse(decodeURIComponent(items))

            if(items.items && items.items.length > 0){
                let kxkuid = localStorage.getItem('kxkuid') || null;
                let localEtsId = localStorage.getItem('localEtsId') || null;
                jsonToPost = {};
                jsonToPost = items;
                jsonToPost.ids = {
                    "uid": localEtsId, 
                    "kx": kxkuid
                };
                jsonToPost.ctx = "hp";
                jsonToPost.page = 0;
                jsonToPost.url = document.location.href;

                jsonToPost.items = jsonToPost.items.filter((item)=>{
                    if(item.urlRewrited.indexOf(' ') === -1 && item.urlRewrited.indexOf('%20') === -1) {
                        return item;
                    }
                })

                console.log('[Raccomandatore] jsonToPost',jsonToPost);
                console.log('[Raccomandatore] jsonToPost1',JSON.stringify(jsonToPost));

                if(jsonToPost.items.length > 0) {
                    let response = await fetch('https://x77l9u4vif.execute-api.eu-west-1.amazonaws.com/prod/api/recommender/gz/v1/hp/',{
                            method: 'POST',
                            headers: {
                                'content-type': 'application/json'
                            },
                            body: JSON.stringify(jsonToPost)
                        });

                    let itemsCarousel = await response.json();
                    console.log('[Raccomandatore] Risultati Fetch', itemsCarousel);

                    var raccomandatore = new raccomandationHandler(itemsCarousel);
                    raccomandatore.init();
                }
            }
            //Qui ci si inserisce per attivare il carousel
        }
    }
})();

function raccomandationHandler(res){
    var me = this;
    me.placeholder;
    me.data;

    me.init = () => {
        me.placeholdersMainCarousel = document.querySelectorAll('.gz-raccomandatore-slide');    
        me.placeholders = document.querySelectorAll('.gz-raccomandatore-swiper');
        me.data = res ? res : null;

        if(!me.data) {
            return;
        }

        if(device != 'desktop') {
            me.populateMainCarousel();
        }
        me.populateCarousels();
    };

    me.populateMainCarousel = () => {
        let data = me.data['nodo_out'].slice(0,me.placeholdersMainCarousel.length);
        
        for(let i=0; i < data.length; i++){
            let el = me.createMainSlide(data[i]);
            let placeholder = me.placeholdersMainCarousel[i];
            placeholder.setAttribute('data-ets-algo', data.algo);
            placeholder.setAttribute('data-ets-tipo', data.tipo);
            placeholder.innerHTML = el;

            if(status1 && typeof window['checkCollections'] === 'function') {
                checkCollections.setButtons(placeholder);
            }
        }

        swiperHelper.overrideMainCarouselSlides();
    };

    me.populateCarousels = () => {
        for(let i=0; i<me.placeholders.length; i++){
            var html = '';

            let placeholder = me.placeholders[i];
            let data = me.data['nodo_out' + placeholder.getAttribute('data-swipernode')];

            for (let j = 0; j < data.length; j++) {
                var el = me.createSlide(data[j]);
                html += el;
            }
    
            placeholder.innerHTML = placeholder.innerHTML + html;
            placeholder.parentNode.classList.add('processed');
            if(status1 && typeof window['checkCollections'] === 'function') {
                checkCollections.setButtons(placeholder);
            }
            
            if(device == 'desktop') {
                if(data.length > 4){
                    mondadoriMediaCarousel.setControls();
                } else {
                    placeholder.parentNode.querySelector('.gz-swiper-info .gz-swiper-button-wrap').style.display = "none";
                }
            }
        }
    };

    me.createMainSlide = (el) => {
        var html = '';

        html += '<article class="gz-card">' +
                    '<div class="gz-btn-link gz-add-preferiti gz-add-preferiti-processed" data-recipeid="' + el.id + '"><span class="gz-btn-icon gz-icon"></span></div>' +
                    '<a href="' + el.url + '" title="' + el.titolo + '">' +
                        '<div class="gz-card-image gz-' + el.type + '">' +
                            '<picture>' +
                                '<img src="' + el.img + 'foto_hd/hd780x520.jpg"" alt="' + el.titolo + '" width="780" height="520" />' +
                            '</picture>' +
                        '</div>' +
                        '<div class="gz-card-content">';
                        if(el.benessere) {
                            html += '<div class="gz-label gz-btn-link gz-benessere"><span class="gz-icon gz-btn-icon"><svg viewBox="0 0 50 50"><use xlink:href="/style/images/icons.svg?cb='+nonce+'#icon-benessere" /></svg></span><span class="gz-btn-label">' + dictionary.benessere + '</span></div>';
                        }
                        html += '<h2 class="gz-title">' + el.titolo + '</h2>';
        if(el.num_commenti || el.rating_average) {
                            html += '<ul class="gz-card-data">';
            if(el.num_commenti) {
                                html += '<li class="gz-single-data-recipe">';
                if(el.num_commenti >= 200) {
                                    html += '<span class="gz-icon"><svg viewBox="0 0 17 18"><use xlink:href="/style/images/icons.svg?cb='+nonce+'#commento-orange" /></svg></span>';
                } else {
                                    html += '<span class="gz-icon"><svg viewBox="0 0 24 25"><use xlink:href="/style/images/icons.svg?cb='+nonce+'#commento-grey" /></svg></span>';
                }
                                    html += el.num_commenti +
                                '</li>';
            }

            if(el.rating_average) {
                                html += '<li class="gz-single-data-recipe">';
                if(el.rating_average >= 4.3) {
                                    html += '<span class="gz-icon"><svg viewBox="0 0 18 16"><use xlink:href="/style/images/icons.svg?cb='+nonce+'#voto-orange" /></svg></span>';
                } else {
                                    html += '<span class="gz-icon"><svg viewBox="0 0 21 20"><use xlink:href="/style/images/icons.svg?cb='+nonce+'#voto-grey" /></svg></span>';
                }
                                        html += el.rating_average +
                                '</li>';
            }
                            html += '</ul>';
        }
                        html += '</div>' +
                    '</a>' +
                '</article>';

        return html;
    };

    me.createSlide = (el) => {
        var html = '';
        var sp = ''; //GZ-1992 el.t_has_special_image ? '_sp' : '';

        html += '<div class="gz-swiper-slide mmCarouselItem" data-ets-algo="'+ el.algo +'" data-ets-tipo="'+ el.tipo +'">' +
                    '<article class="gz-card gz-card-vertical">' +
                        '<div class="gz-btn-link gz-add-preferiti gz-add-preferiti-processed" data-recipeid="' + el.id + '"><span class="gz-btn-icon gz-icon"></span></div>' +
                        '<a href="' + el.url + '" title="' + el.titolo + '">' +
                            '<div class="gz-card-image gz-' + el.type + '">' +
                                '<picture>' +
                                    '<img src="' + el.img + 'foto_hd/hd360x300' + sp + '.jpg" alt="' + el.titolo + '" width="360" height="300" class="lazyload" loading="lazy" />';
        if(el.benessere) {
            html += '<div class="gz-label gz-btn-link gz-benessere"><span class="gz-icon gz-btn-icon"><svg viewBox="0 0 50 50"><use xlink:href="/style/images/icons.svg?cb='+nonce+'#icon-benessere" /></svg></span><span class="gz-btn-label">' + dictionary.benessere + '</span></div>';
        }
                                html += '</picture>' +
                            '</div>' +
                            '<div class="gz-card-content">' +
                                '<h4 class="gz-title gz-line-clamp gz-line-clamp-2">' + el.titolo + '</h4>';
        if(el.num_commenti || el.rating_average) {
                                html += '<ul class="gz-card-data">';
            if(el.num_commenti) {
                                    html += '<li class="gz-single-data-recipe">';
                if(el.num_commenti >= 200) {
                                        html += '<span class="gz-icon"><svg viewBox="0 0 17 18"><use xlink:href="/style/images/icons.svg?cb='+nonce+'#commento-orange" /></svg></span>';
                } else {
                                        html += '<span class="gz-icon"><svg viewBox="0 0 24 25"><use xlink:href="/style/images/icons.svg?cb='+nonce+'#commento-grey" /></svg></span>';
                }
                                        html += el.num_commenti +
                                    '</li>';
            }

            if(el.rating_average) {
                                    html += '<li class="gz-single-data-recipe">';
                if(el.rating_average >= 4.3) {
                                        html += '<span class="gz-icon"><svg viewBox="0 0 18 16"><use xlink:href="/style/images/icons.svg?cb='+nonce+'#voto-orange" /></svg></span>';
                } else {
                                        html += '<span class="gz-icon"><svg viewBox="0 0 21 20"><use xlink:href="/style/images/icons.svg?cb='+nonce+'#voto-grey" /></svg></span>';
                }
                                        html += el.rating_average +
                                    '</li>';
            }
                                html += '</ul>';
        }
                            html += '</div>' +
                        '</a>' +
                    '</article>' +
                '</div>';

        return html;
    };

}

(handlePermanenceEvent = () => {
    var count = 1;
    var delay = 15000;
    var times = 40;

    let timerEvent = setInterval(() => {
        /*
        eventAnalytics('15sec', 'PermanenzaHP', count, true);
        */
        count++;
    }, delay);

    setTimeout(() => { clearInterval(timerEvent); }, delay * times);
})();

(handleAutoPlayOnMainSwiper = () => {
    document.addEventListener('initSwiper', event => {
        let swiperContainer = document.querySelector('.gz-tiramisu');
        let isStopped = false;
        
        if(device != 'desktop' && swiperContainer) {
            let name = swiperContainer.querySelector(':scope > .gz-swiper-container') ? swiperContainer.querySelector(':scope > .gz-swiper-container').dataset.swipername : '';
            
            if(name && name == event.detail.swipername && typeof(swiperHelper) !== "undefined") {
                let swipers = swiperHelper.getSwipers();
                let mainSwiper = swipers[name].swiper;

                let observer = new IntersectionObserver((entries, observer) => { 
                    entries.forEach(entry => {
                        if(entry.intersectionRatio != 1){
                            if(isStopped) {
                                mainSwiper.autoplay.start(); 
                                isStopped = false;
                            } else {
                                mainSwiper.autoplay.stop(); 
                                isStopped = true;
                            }
                            mainSwiper.update();
                        }
                    });
                }, {threshold: 0});
                observer.observe(swiperContainer);

                document.addEventListener("visibilitychange", event => {
                    if(document.hidden) {
                        if(!isStopped){
                            mainSwiper.autoplay.stop(); 
                        }
                    } else {
                        if(!isStopped){
                            mainSwiper.autoplay.start(); 
                        }
                    }
                    mainSwiper.update();
                }, false);
            }
        }
    });
})();

let advCarouselsContainers = document.querySelectorAll('.gz-carousel-adv-container');

if(advCarouselsContainers.length) {
    advCarouselsContainers.forEach(container => {
        let carousels = container.querySelectorAll('.gz-carbonara');
        if(carousels.length > 1) {
            let randomCarouselIndex = Math.floor(Math.random() * carousels.length);
            for(let i=0; i<carousels.length; i++) {
                if(i != randomCarouselIndex) {
                    carousels[i].remove();
                }
            }
        } 

        let carousel = container.querySelector('.gz-carbonara');
        carousel.classList.add('processed');
    });
}

// GZ-2530 — carousel classifiche Top ristoranti
(() => {
    const rankingsSlider = document.querySelector('.gz-carousel-content .gz-toplist-slider');
    if (!rankingsSlider) return;

    const initRankingsCarousel = () => {
        const dotsContainer = rankingsSlider.parentNode.querySelector('.gz-toplist-dots');
        const rankingSlides = [...rankingsSlider.children];
        const dots = [...dotsContainer.children];

        const shuffledOrder = rankingSlides.map((_, index) => index);
        for (let index = shuffledOrder.length - 1; index > 0; index--) {
            const swapIndex = Math.floor(Math.random() * (index + 1));
            [shuffledOrder[index], shuffledOrder[swapIndex]] = [shuffledOrder[swapIndex], shuffledOrder[index]];
        }
        shuffledOrder.forEach((originalIndex) => {
            rankingsSlider.appendChild(rankingSlides[originalIndex]);
            dotsContainer.appendChild(dots[originalIndex]);
        });

        const orderedSlides = [...rankingsSlider.children];
        const orderedDots = [...dotsContainer.children];

        const setActiveDot = (activeIndex) => {
            orderedDots.forEach((dot, index) => dot.classList.toggle('gz-toplist-dot-active', index === activeIndex));
        };

        orderedDots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
                rankingsSlider.scrollTo({ left: orderedSlides[index].offsetLeft, behavior: 'smooth' });
            });
        });
        setActiveDot(0);

        const visibilityObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setActiveDot(orderedSlides.indexOf(entry.target));
                }
            });
        }, { root: rankingsSlider, threshold: 0.6 });

        orderedSlides.forEach((slide) => visibilityObserver.observe(slide));

        rankingsSlider.scrollTo({ left: 0, behavior: 'instant' });
        setActiveDot(0);

        rankingsSlider.classList.add('processed');
        dotsContainer.classList.add('processed');
    };

    const proximityObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                observer.disconnect();
                initRankingsCarousel();
            }
        });
    }, { rootMargin: '150px 10px 150px 10px' });

    proximityObserver.observe(rankingsSlider);
})();
